<template>
  <div>
    <a-drawer :destroy-on-close="true" :title="title" :width="960" :visible="visible" :body-style="{ paddingBottom: '80px' }" :mask-closable="false" @close="cancel">
      <a-form-model ref="form" :rules="rules" :model="form" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="18">
            <a-form-model-item label="标题" prop="title">
              <a-input v-model="form.title" placeholder="请填写标题" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="状态" prop="status">
              <a-radio-group v-model="form.status" name="radioGroup" button-style="solid">
                <a-radio-button v-for="(items, index) in changelogStatus" :key="index" :value="items.value"> <a-badge :color="items.color" :text="items.label" /> </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="迭代号" prop="version">
              <a-input v-model="form.version" placeholder="请填写迭代号" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="发布时间" prop="release_time">
              <a-date-picker v-model="form.release_time" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择发布时间" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="轮播图" prop="images">
              <a-upload :action="actionUrl" name="resource" :headers="headers" :data="data" :file-list="imageList" list-type="picture-card" @change="handleChange" @preview="handlePreview">
                <div v-if="imageList.length < 3">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">Upload</div>
                </div>
              </a-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="发布内容" prop="content">
              <vditor-editor v-model="form.content" :height="385" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="drawer-bottom-menu">
        <a-button :style="{ marginRight: '8px' }" @click="onClose"> 取消 </a-button>
        <a-button type="primary" @click="onSubmit"> 提交 </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { changelogAdd, changelogModify, changelogDetail } from '@/api/system/about';
import VditorEditor from '@/components/VditorEditor';
import { changelogStatus } from '@/utils/dictionary';
import { getCookies } from '@/utils/utils';

var moment = require('moment');

export default {
  components: {
    VditorEditor
  },
  props: {
    changelogId: {
      type: [Number, String],
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        content: ''
      },
      changelogStatus,
      imageList: [],
      actionUrl: `${process.env.VUE_APP_DADA_URL}/v1/basic/resourceUpload`,
      headers: {
        Authorization: getCookies()
      },
      data: {
        resource_type: 1
      },
      rules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
        version: [{ required: true, message: '迭代号不能为空', trigger: 'blur' }],
        release_time: [{ required: true, message: '发布时间不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '发布内容不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    title() {
      return this.changelogId ? '修改日志' : '添加日志';
    }
  },
  watch: {
    visible() {
      if (this.visible === true) {
        this.imageList = [];
        this.form = {
          content: '',
          release_time: null
        };
        if (this.changelogId) {
          this.getDetail();
        }
      }
    }
  },
  methods: {
    onClose() {
      this.form = {};
      this.$refs.form.resetFields();
      this.$emit('close');
    },

    cancel() {
      this.$emit('cancel');
    },

    getImages() {
      return this.imageList.map(image => {
        if (image.status === 'done') {
          if (image.response && image.response.data.resource_url !== null) {
            return image.response.data.resource_url;
          } else if (image.url) {
            return image.url;
          }
        }
      });
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          this.form.images = this.getImages();
          if (this.changelogId) {
            changelogModify({ ...this.form, changelog_id: this.changelogId })
              .then(() => {
                this.form.content = '';
                this.$message.success('修改成功');
                this.onClose();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            changelogAdd(this.form)
              .then(() => {
                this.form.content = '';
                this.$message.success('添加成功');
                this.onClose();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },

    handlePreview(file) {
      window.open(file.url || file.response.data.resource_url);
    },

    handleChange({ fileList }) {
      if (fileList instanceof Array) {
        this.imageList = fileList;
      }
    },

    // 获取日志详情
    getDetail() {
      changelogDetail({ changelog_id: this.changelogId }).then(res => {
        this.form = res.data;
        this.form.release_time = res.data.release_time ? moment(res.data.release_time, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
        this.imageList = res.data.images.map((image, index) => {
          return {
            uid: `${0 - (index + 1)}`,
            name: `IMG-${index}.png`,
            status: 'done',
            url: image
          };
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.http-url {
  color: rgb(133, 133, 133);
}
.drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
</style>
